
// // Import the functions you need from the SDKs you need
// import { initializeApp } from "https://www.gstatic.com/firebasejs/9.6.7/firebase-app.js";
// import { getAnalytics } from "https://www.gstatic.com/firebasejs/9.6.7/firebase-analytics.js";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: "AIzaSyCO_S0bCM3VkQnEBdTWwjaygqJpZd7kHBc",
//     authDomain: "mapa-onpsc.firebaseapp.com",
//     projectId: "mapa-onpsc",
//     storageBucket: "mapa-onpsc.appspot.com",
//     messagingSenderId: "342933695545",
//     appId: "1:342933695545:web:e9cbb58771e865062171e8",
//     measurementId: "G-N71Y0R44YC"
// };

// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

// var db = firebase.firestore();
// Your web app's Firebase configuration

const firebaseConfig = {
    apiKey: "AIzaSyCO_S0bCM3VkQnEBdTWwjaygqJpZd7kHBc",
    authDomain: "mapa-onpsc.firebaseapp.com",
    projectId: "mapa-onpsc",
    storageBucket: "mapa-onpsc.appspot.com",
    messagingSenderId: "342933695545",
    appId: "1:342933695545:web:e9cbb58771e865062171e8",
    measurementId: "G-N71Y0R44YC"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();






function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray(prmstr) {
    var params = {};
    var prmarr = prmstr.split("&");
    for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

var params = getSearchParameters();

if(params.panel == "false") {
    document.querySelector("#mapa_principal").className = "p-0 h-100 w-100 position-fixed contenedor_mapa"

    document.querySelector("#panel_lateral").className = "d-none"
}



var app = new Vue({
    el: "#vue_app",
    data() {
        return {
            provincias: ["Buenos Aires", "Capital Federal", "Catamarca", "Chaco", "Chubut", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"],
            provincias_IATA: ["BA", "CAP", "CA", "CH", "CT", "CB", "CR", "ER", "FO", "JY", "LP", "LR", "MZ", "MI", "NQN", "RN", "SA", "SJ", "SL", "SC", "SF", "SE", "TF", "TU"],

            tipos_lugar: ["Organización Social", "Organismo Público", "Organismo Privado", "Equipo de Investigación", "Otro"],
            tipos_lugar_short: ["organizacion", "organismo_pub", "organismo_priv", "equipo", "otro"],
            array_lugares: [],
            array_lugares_filtrados: [],
            search: "",
            filtros: {
                tipo:"",
                provincia: ""
            }

        }
    },
    created() {








        db.collection("lugares").doc("block_1")
            .get()
            .then(function (querySnapshot) {
                console.log(querySnapshot)
                console.log(querySnapshot.data())
                block_firebase = querySnapshot.data()

                block_firebase.array_lugares.forEach(element => {
                    element.ubicacion.provincia_IATA = app.provincias_IATA[app.provincias.indexOf(element.ubicacion.provincia)]

                    element.tipo_long = app.tipos_lugar[app.tipos_lugar_short.indexOf(element.tipo)]

                    element.keys = element.ubicacion.provincia + " " + element.tipo
                });



                app.array_lugares = block_firebase.array_lugares

                app.map_leaf = L.map('map').setView([-32, -64], 5);

                // Usamos estos iconos https://github.com/pointhi/leaflet-color-markers

                var greenIcon = new L.Icon({
                    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
                    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });

                var redIcon = new L.Icon({
                    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
                    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });

                // Proveedor OpenStreetMap
                // OpenStreetMap: http://tile.openstreetmap.org/{z}/{x}/{y}.png
                // OpenStreetMap Alemania: http://tile.openstreetmap.org/{z}/{x}/{y}.png

                
                // Proveedor Google
                // Google Maps: https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}
                
                // Google Satellite: http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}&s=Ga
                
                // Google Hybrid: https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}G
                
                // Google Traffic: https://mt1.google.com/vt?lyrs=h@159000000,traffic|seconds_into_week:-1&style=3&x={x}&y={y}&z={z}
                
                // Google Roads: https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}

                L.tileLayer('https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}', {
                    attribution: 'Mapa &copy; <a href="http://openstreetmap.org">OpenStreetMap</a>',
                    maxZoom: 18
                }).addTo(app.map_leaf);

                for (let punto of app.array_lugares) {
                    console.log("aca")

                    popup_html = `<div><h5>${punto.nombre}</h5>
                    <div class="p-2 bg-light rounded">
                    <table>
                                `

                    if (punto.direccion != "") {
                        popup_html += `<tr>
                        <td class="celda_icono"><span class="fa-solid fa-location-dot"></span></td>
                        <td class="p-1"><div class="celda_data">${punto.ubicacion.direccion}, ${punto.ubicacion.ciudad}, ${punto.ubicacion.provincia}</div></td>
                    </tr>
                
                `
                    }

                    if (punto.descripcion != "") {
                        popup_html += `<tr>
                        <td class="celda_icono"><span class="fas fa-info-circle"></span></td>
                        <td class="p-1"><div class="celda_data">${punto.descripcion}</div></td>
                    </tr>
                `
                    }
                    if (punto.telefono != "") {
                        popup_html += `
                    <tr>
                        <td class="celda_icono"><span class="fas fa-phone"></span></td>
                        <td class="p-1"><div class="celda_data">${punto.telefono}</div></td>
                    </tr>
                `
                    }
                    if (punto.email != "") {
                        popup_html += `
                    <tr>
                        <td class="celda_icono"><span class="fas fa-envelope"></span></td>
                        <td class="p-1"><div class="celda_data">${punto.email}</div></td>
                    </tr>
                `
                    }

                    if (params.location != undefined) {
                    
                        variable_location = decodeURIComponent(params.location)
                    } else {
                        variable_location = window.location.origin
                    }

                    console.log(variable_location)
                    popup_html += `</table></div>
                    <hr><div class="d-flex flex-row justify-content-center flex-wrap">
                    `
                    if (punto.link_prin != "") {
                        popup_html += `<div class="col-6 p-1"><button class="btn btn-primary btn-sm w-100" onclick="window.open('${punto.link_prin}', '_blank');">Ver más</button></div>
                        
                        <div class="col-6 p-1">
                    <button class="btn btn-primary btn-sm w-100" onclick="
                    navigator.clipboard.writeText(variable_location + '?lugar=${punto.simple}')
                    .then(() => {
                        mdtoast('Link copiado al portapapeles', { duration: 5000, type: mdtoast.SUCCESS });
                })
                    .catch(err => {
                    console.log('Something went wrong', err);
                })
            ">Compartir</button>
                    </div>`
                    } else {
                        popup_html += `
<div class="col-12 p-1">
                    <button class="btn btn-primary btn-sm w-100" onclick="
                    navigator.clipboard.writeText(variable_location + '?lugar=${punto.simple}')
                    .then(() => {
                        mdtoast('Link copiado al portapapeles', { duration: 5000, type: mdtoast.SUCCESS });
                })
                    .catch(err => {
                    console.log('Something went wrong', err);
                })
            ">Compartir</button>
                    </div>`
                    }
                    
                    if (punto.link_int != "") {
                        popup_html += `<div class="col-12 p-1">
                        <button class="btn btn-secondary btn-sm w-100" onclick="window.open('${punto.link_int}', '_blank');">Ver publicaciones relacionadas</button></div>`
                    }
                    popup_html += "</div>"
                    
                    
                    
                    punto.marker = L.marker([punto.ubicacion.coordenadas.lat, punto.ubicacion.coordenadas.lng], {

                    }).addTo(app.map_leaf).bindPopup(popup_html)


                }

                if (params.lugar != undefined) {
                    app.abrirLugar(params.lugar)
                }

            }).catch(function (error) {
                // mdtoast('Error al mostrar las mesas, volvé a cargar el sitio.<br><small>Si el error continúa avisá a soporte.</small>', { duration: 15000, type: mdtoast.ERROR });
                console.log(error)
            });




    },
    computed: {
        lugaresClassifiedProvincias: function () {
            return this.array_lugares.reduce(function (rv, x) {
                (rv[x.ubicacion["provincia"]] = rv[x.ubicacion["provincia"]] || []).push(x);
                return rv;
            }, {});

        }

    },
    methods: {
        collapseProvincia: function (name) {
            var mapa_bs = new bootstrap.Collapse(document.querySelector("#provincia_" + name),{
                toggle: true
              })

            mapa_bs.show()
        },
        filtrar_lugares: function (search) {
            if(app.filtros.tipo != "" || app.filtros.provincia != "" ) {
                
                 app.filtrarEspecifico()
                const fuse = new Fuse(app.array_lugares_filtrados, {
                    keys: ['nombre', 'ubicacion.ciudad', 'ubicacion.direccion', 'ubicacion.provincia', 'descripcion', 'tipo', 'tipo_long'],
                    threshold: 0.4
                })
                console.log(2)
                app.array_lugares_filtrados = fuse.search(search).map(function(x) {
                    return x.item;
                 });
                 
                 if(search == ""){
                    app.filtrarEspecifico()
                 }
            } else {
                if(search != ""){
                    const fuse = new Fuse(app.array_lugares, {
                        keys: ['nombre', 'ubicacion.ciudad', 'ubicacion.direccion', 'ubicacion.provincia', 'descripcion', 'tipo', 'tipo_long'],
                        threshold: 0.4
                    })
                    console.log(1)
                    app.array_lugares_filtrados = fuse.search(search).map(function(x) {
                        return x.item;
                     });
    
                     if(search == ""){
                        app.filtrarEspecifico()
                     }
                } else {
                    var contenedor_busqueda = new bootstrap.Collapse(document.querySelector("#contenedor_busqueda"),{
                        toggle: false
                      })
        
                    contenedor_busqueda.hide()

                    return false
                }
                
            }
            

            
            console.log(app.array_lugares_filtrados)

            var contenedor_busqueda = new bootstrap.Collapse(document.querySelector("#contenedor_busqueda"),{
                toggle: false
              })

            contenedor_busqueda.show()

        },


        abrirLugar: function (id_lugar) {


            app.map_leaf.flyTo(app.array_lugares[app.array_lugares.findIndex((element) => element.simple == id_lugar)].marker.getLatLng(), 12)

            app.array_lugares[app.array_lugares.findIndex((element) => element.simple == id_lugar)].marker.openPopup()
        },
        filtrarEspecifico:function(){
            // if(app.filtros.tipo != "" && app.filtros.provincia == "") {
            // app.array_lugares_filtrados = app.array_lugares.filter(el => el.tipo == app.filtros.tipo);
            // console.log(1)
                
            // }

            // if(app.filtros.tipo == "" && app.filtros.provincia != "") {
            //     app.array_lugares_filtrados = app.array_lugares.filter(el => el.provincia == app.filtros.provincia);
            //     console.log(2)

            // }

            // if(app.filtros.tipo != "" && app.filtros.provincia != "") {
            //     app.array_lugares_filtrados = app.array_lugares.filter(el => el.tipo == app.filtros.tipo && el.provincia == app.filtros.provincia);
            //     console.log(3)


            // }

            const fuse = new Fuse(app.array_lugares, {
                keys: ['keys'],
                threshold: 0.4
            })

            app.array_lugares_filtrados = fuse.search(app.filtros.provincia + " " + app.filtros.tipo).map(function(x) {
                    return x.item
                 })
            //  console.log(fuse.search(app.filtros.provincia + " " + app.filtros.tipo).map(function(x) {
            //     return x
            //  }))

             var contenedor_busqueda = new bootstrap.Collapse(document.querySelector("#contenedor_busqueda"),{
                toggle: false
              })

            contenedor_busqueda.show()
        },
        descargarCSV:function(){
            function convertToCSV(objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
                var str = '';
            
                for (var i = 0; i < array.length; i++) {
                    var line = '';
                    for (var index in array[i]) {
                        if (line != '') line += ','
            
                        line += array[i][index];
                    }
            
                    str += line + '\r\n';
                }
            
                return str;
            }
            
            function exportCSVFile(headers, items, fileTitle) {
                if (headers) {
                    items.unshift(headers);
                }
            
                // Convert Object to JSON
                var jsonObject = JSON.stringify(items);
            
                var csv = convertToCSV(jsonObject);
            
                var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
            
                var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                if (navigator.msSaveBlob) { // IE 10+
                    navigator.msSaveBlob(blob, exportedFilenmae);
                } else {
                    var link = document.createElement("a");
                    if (link.download !== undefined) { // feature detection
                        // Browsers that support HTML5 download attribute
                        var url = URL.createObjectURL(blob);
                        link.setAttribute("href", url);
                        link.setAttribute("download", exportedFilenmae);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            }
            
            var headers = {
                nombre: 'Nombre'.replace(/,/g, ''), // remove commas to avoid errors
                tipo_long: "Tipo",
                provincia: "Provincia",
                ciudad: "Ciudad",
                direccion: "Dirección",
                telefono: "Teléfono",
                email: "Email",
                descripcion: "Descripción",
                link_prin: "Link Principal",
                link_int: "Link Observatorio",
                simple: "ID Mapa"
            };
            
            
            
            var itemsFormatted = [];
            
            // format the data
            app.array_lugares_filtrados.forEach((item) => {
                itemsFormatted.push({


                    nombre: item.nombre.replace(/,/g, ''),
                    tipo_long: item.tipo_long.replace(/,/g, ''),
                    provincia: item.ubicacion.provincia.replace(/,/g, ''),
                    ciudad: item.ubicacion.ciudad.replace(/,/g, ''),
                    direccion: item.ubicacion.direccion.replace(/,/g, ''),
                    telefono: item.telefono.replace(/,/g, ''),
                    email: item.email.replace(/,/g, ''),
                    descripcion: item.descripcion.replace(/,/g, ''),
                    link_prin: item.link_prin.replace(/,/g, ''),
                    link_int: item.link_int.replace(/,/g, ''),
                    simple: item.simple.replace(/,/g, '')



                });
            });
            
            var fileTitle = "resultados-" + app.search.replaceAll(" ", "-"); // or 'my-unique-title'
            
            exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
        }
    },
    mounted: function () {
    }
})

